import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import ConsumerHeader from '../../../consumer-header/ConsumerHeader';
import Icon from '../../../../icons/Icon';
import { ICONS } from '../../../../icons';
import CommonButton, { BUTTON_STYLES } from '../../../../components/common-button/CommonButton';
import {
  LANGUAGES_SHORT,
  PROJECT_TYPES,
  RESONANCE_STRUCTURE,
  RESONANCE_THEMES,
  RESONANCE_VISIONS,
} from '../../../../constants';

import scss from './Header.module.scss';

function Header() {
  const { t } = useTranslation('resonance');

  const { projectName, theme, vision, dataStructure, lang } = useSelector((state) => state.resonance.projectInfo);
  const serverUrl = useSelector((state) => state.securityNew.serverUrl);
  const projectPassword = useSelector((state) => state.consumer.resonance.projectPassword);
  const projectApiName = useSelector((state) => state.consumer.resonance.projectName);

  const [isLoading, setIsLoading] = useState(false);

  const redirectToResonance = async () => {
    setIsLoading(true);

    const query = [
      `projectName=${projectApiName}`,
      `projectType=${PROJECT_TYPES.RESONANCE}`,
      `projectPassword=${projectPassword}`,
      `theme=${theme?.toLowerCase() || RESONANCE_THEMES.FACTIVE}`,
      `vision=${vision?.toLowerCase() || RESONANCE_VISIONS.DEFAULT}`,
      `dataStructure=${dataStructure?.toLowerCase() || RESONANCE_STRUCTURE.RESPONDENTS}`,
      `lang=${lang?.toLowerCase() || LANGUAGES_SHORT.ENGLISH}`,
    ];

    setIsLoading(false);
    window.open(`${serverUrl}/chart/resonance/?${query.join('&')}`, '_blank').focus();
  };

  return (
    <ConsumerHeader
      AdditionalActions={
        <CommonButton
          styleColor={BUTTON_STYLES.PRIMARY}
          maxWidth={150}
          onClick={redirectToResonance}
          isLoading={isLoading}
          className={scss.ivisButton}>
          {t('redirectToIvis')}
        </CommonButton>
      }>
      <div className={scss.projectName}>
        <Icon icon={ICONS.Resonance} />
        <h3>{projectName}</h3>
      </div>
    </ConsumerHeader>
  );
}

export default Header;
